














import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import { CURRENCY_KEYS } from '@/constants/currency'

import { PriceData } from '@/store/models'

import { extent } from 'd3-array'
// import { timeFormat } from 'd3-time-format'
import currencyFormatter from 'currency-formatter'

@Component
export default class VerticalAxis extends Vue {
    @Prop({ required: true, type: Array }) data!: Array<PriceData>
    @Prop({
      required: true,
      type: String,
      validator: function (v: string) {
        return CURRENCY_KEYS.indexOf(v) !== -1
      }
    }) currency!: string

    @Prop({ required: true, type: String }) align!: string
    @Prop({ required: true, type: String }) justify!: string

    minPrice = 0
    maxPrice = 0

    @Watch('data')
    onDataChanged (value: Array<PriceData>) {
      const [minPrice, maxPrice] = extent(value, d => d.price)
      this.minPrice = minPrice!
      this.maxPrice = maxPrice!
    }

    formatPrice (price: number) {
      return currencyFormatter.format(price, { code: this.currency, precision: 0 })
    }

    get showMaxPrice () {
      return this.formatPrice(this.maxPrice)
    }

    get showMinPrice () {
      return this.formatPrice(this.minPrice)
    }
}

